/**
 * Tokens extracted from Figma node 1:2229 — “Présences Admin Portal”.
 * Source: https://www.figma.com/design/ln2jXzNQK8vZE5VHfP0htz/Untitled?node-id=1-2229
 */
export const figmaTokens = {
  pageBg: "#f7f9fc",
  surface: "#ffffff",
  borderSubtle: "#e2e8f0",
  borderStrong: "#cbd5e1",
  cardHeaderRule: "#f1f5f9",
  /** Sidebar */
  sidebarBg: "#1e293b",
  sidebarBorder: "#334155",
  sidebarText: "#cad5e2",
  sidebarMuted: "#90a1b9",
  /** Typography */
  pageTitle: "#1d293d",
  textPrimary: "#1e293b",
  textBody: "#344767",
  textSecondary: "#64748b",
  textMuted: "#94a3b8",
  tableHeaderText: "#8392ab",
  /** Purple gradient (buttons, active nav, CTAs) — matches Figma multi-stop simplify */
  gradientStart: "#667eea",
  gradientEnd: "#764ba2",
  gradientCSS: "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
  gradientDiagonalCSS: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  /** Tables */
  tableHeaderBg: "#ffffff",
  tableRowHover: "#f7f9fc",
  /** Status chips (leave page reference) */
  badgePending: "#f0b100",
  badgeApproved: "#00c950",
  badgeDanger: "#ef4444",
  /** Legacy aliases used elsewhere */
  accent: "#667eea",
  accentEnd: "#764ba2",
  focusRing: "rgba(102, 126, 234, 0.35)",
  /**
   * Teacher roster vs capacity donut + “Numbers at a glance” — indigo (filled), teal (open),
   * purple (capacity ceiling). Keeps chart and KPI strip visually aligned.
   */
  rosterChartFilled: "#667eea",
  rosterChartOpen: "#2dd4bf",
  rosterChartCapacity: "#764ba2",
  rosterChartMuted: "#94a3b8",
};

/** Directory tables — dark header bar (sidebar), white bold labels */
export const directoryTableHeaderCellSx = {
  bgcolor: `${figmaTokens.sidebarBg} !important`,
  fontWeight: 800,
  fontSize: "0.68rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "#ffffff !important",
  py: 1.65,
  borderBottom: `2px solid ${figmaTokens.sidebarBorder} !important`,
  whiteSpace: "nowrap",
  zIndex: 3,
};

/** Merge into `<Table sx={{ ... }}>` so theme `MuiTableCell-head` does not override */
export const directoryTableHeadStickyOverridesSx = {
  "& .MuiTableHead-root .MuiTableCell-root.MuiTableCell-head": {
    backgroundColor: `${figmaTokens.sidebarBg} !important`,
    color: "#ffffff !important",
    borderBottom: `2px solid ${figmaTokens.sidebarBorder} !important`,
    fontWeight: 800,
    fontSize: "0.68rem",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    px: 2.25,
    py: 1.65,
    zIndex: 3,
  },
};

export const directoryTableBodyCellDefaultsSx = {
  "& .MuiTableBody-root .MuiTableCell-root": {
    px: 2.25,
    py: 1.45,
    borderBottom: `1px solid ${figmaTokens.borderSubtle}`,
    fontSize: "0.8125rem",
    lineHeight: 1.45,
    verticalAlign: "middle",
    color: figmaTokens.textBody,
    fontWeight: 400,
  },
};
